import React, { memo } from 'react';
import { Layout } from 'react-admin';
import AppMenu from '../AppMenu/AppMenu';
import AppBarCustom from '../AppBar/AppBar';
import AppSideBar from '../AppSideBar/AppSideBar';

const AppLayout = (props) => (
  <Layout {...props} sidebar={AppSideBar} appBar={AppBarCustom} menu={AppMenu} />
);

export default memo(AppLayout);
